import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  ChangeMemberRolePayload,
  FirmMemberDTO,
  InviteMemberPayload
} from '@sollapay/types';

export const teamApi = {
  fetchMembers: async (client: HttpClient): Promise<ApiResponse<FirmMemberDTO[]>> =>
    client.get<ApiResponse<FirmMemberDTO[]>>('/users'),

  inviteMember: async (
    client: HttpClient,
    payload: InviteMemberPayload
  ): Promise<ApiResponse<FirmMemberDTO>> =>
    client.post<ApiResponse<FirmMemberDTO>, InviteMemberPayload>('/users/invite', payload),

  changeMemberRole: async (
    client: HttpClient,
    memberId: string,
    payload: ChangeMemberRolePayload
  ): Promise<ApiResponse<FirmMemberDTO>> =>
    client.patch<ApiResponse<FirmMemberDTO>, ChangeMemberRolePayload>(
      `/users/${memberId}/role`,
      payload
    ),

  removeMember: async (client: HttpClient, memberId: string): Promise<void> =>
    client.delete<void>(`/users/${memberId}`)
};
